import {RouteObject} from "react-router-dom";
import StadiumManage from "./StadiumManage";
import StadiumDetailManage from "./StadiumDetailManage";
import AuthGuardWrapper from "../../auth/AuthGuardWrapper";
import {Stadium} from "../../../commons/models/stadium";

export const routerAdminStadium: RouteObject[] = [
    {
        path: "",
        element: <AuthGuardWrapper subject={Stadium}><StadiumManage/></AuthGuardWrapper>,
    },
    {
        path: ":stadiumId",
        element: <AuthGuardWrapper subject={Stadium}> <StadiumDetailManage/></AuthGuardWrapper>,
    },
];
